export default __webpack_public_path__ + "static/media/Nunito-ExtraBold.4744fef0.woff";